<template>
  <div class="tw-absolute tw-inset-0 tw-bg-white/90"></div>
  <div
    class="
      tw-absolute
      tw-inset-0
      tw-flex
      tw-items-center
      tw-justify-center
      tw-flex-col
      tw-rounded-lg
      tw-px-4
      tw-py-12
      tw-bg-violet-500/10
    "
  >
    <div
      class="
        tw-w-[54px]
        tw-h-[54px]
        tw-rounded-full
        tw-bg-sf-snow
        tw-flex
        tw-items-center
        tw-justify-center
      "
    >
      <div
        class="fa fa-wand-magic-sparkles tw-text-sf-ai-light-2 tw-text-2xl"
      />
    </div>
    <div class="tw-text-center">
      <div class="tw-text-[16px] tw-font-bold">{{ copy.title }}</div>
      <div class="tw-text-[14px]">
        {{ copy.subtitle }}
      </div>
    </div>
    <SfLoadingDots class="tw-mt-3" />
  </div>
</template>
<script setup lang="ts">
import useI18n from '@app/shared/vue/composables/use-I18n'
import SfLoadingDots from '@app/shared/vue/components/loaders/sf-loading-dots.vue'

const I18n = useI18n()
const copy = {
  title: I18n.t('client_meetings.proposal_finalizing.title'),
  subtitle: I18n.t('client_meetings.proposal_finalizing.subtitle'),
}
</script>
